// LICENSE_CODE ZON
'use strict'; /*jslint browser:true, es6:true, node:true, react:true*/
import React, {useState, useContext, useEffect} from 'react';
import {useLocation, useHistory} from 'react-router-dom';
import {useTranslation, Trans} from 'react-i18next';
import cn from 'classnames';

import www_util from 'hola_pub_util';

import zurl from '/util/url.js';
import etask from '/util/etask.js';
import csrf from '/util/csrf.js';
// @ts-ignore
import {fetch} from '/util/fetch.js';
// @ts-ignore
import {App_context} from '../../context.js';
import {Input} from '../../lib/input.js';
import {Button} from '../../../../shared/button';

import styles from './password.module.less';

const T = (props: any)=><Trans {...props}
  components={{br: <br/>}}/>;

export const Root = ()=>{
    const {user} = useContext(App_context);
    const {t} = useTranslation();
    const history = useHistory();
    const {search} = useLocation();
    const qs = zurl.qs_parse(search.substr(1), {safe: true});
    const default_email: string = user?.emails?.[0]?.value || qs.email || '';
    const [email, set_email] = useState(default_email);
    const [error, set_error] = useState('');
    useEffect(()=>{
      www_util.perr_www_visit({id: 'www_forgot_password_visit', user});
    }, []);
    const on_submit = e=>{
        e.preventDefault();
        if (!zurl.is_valid_email(email))
            return void set_error('Please enter a valid email address.');
        etask(function*(){
            const res = yield fetch('/users/send_reset_password_mail', {
                method: 'POST',
                body: {email, csrf_token: csrf.get(), ajax: true},
            });
            if (res && res.sent)
                history.push(`/forgot_password_success?email=${email}`);
            else
            {
                set_error('We\'ve encountered an error. '+
                    'Please, try again later.');
            }
        });
    };
    const on_change = value=>{
        set_email(value);
        if (error)
            set_error('');
    };
    const title_key = qs.reset
        ? 'forgot_password_2.form.title_reset'
        : 'forgot_password_2.form.title_forgot';
    return <form
      role="form"
      onSubmit={on_submit}
      className={cn(styles.forgot_password, styles.password_page)}
    >
      <div className={styles.img}/>
      <h2><T i18nKey={title_key} /></h2>
      <p><T i18nKey="forgot_password_2.form.text"/></p>
      <Input type="text" value={email} on_change={on_change}
        error={error}
        cl={styles.input} name="email"
        label={t('forgot_password_2.form.label')}
        placeholder={t('forgot_password_2.form.placeholder')} />
      <Button
        round arrow
        caption={t('forgot_password_2.form.button')}
        clickid="send_reset_password_link"
        on_click={on_submit} />
    </form>;
};

Root.meta = {
  headless: false,
  footless: true,
  default_theme: 'hola2023',
  ssr_force: false,
  no_ssr: true,
  meta: ()=>{
    return {
      title: 'Hola | Did You Forget Your Login Password?',
      description: 'Forgotten your password? Don\'t worry. You can '
          +'quickly and easily reset your password in just a few simple '
          +'steps. Take action now to regain access to your account.',
      canonical_url: 'https://hola.org/forgot_password',
    };
  },
};

